import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router";
import TemplateInstanceProvider from "../../../../Providers/TemplateInstanceProvider";
import { useShoppingCart } from "../../../providers/ShoppingCartProvider";
import PackageInstanceProvider, {
  ACTIONS_SET_ADDED_TO_CART,
  ACTIONS_SET_ADDING_TO_CART,
  editPackageForceSetSameSubject,
  usePackageInstance,
} from "../../../../Providers/PackageInstanceProvider";
import MobilePage from "../../../Components/MobilePage";
import AppBar from "../AppBar";
import EditPackage from "./EditPackage";
import GreenScreenBackgroundsProvider from "../../Providers/GreenScreenBackgroundsProvider";
import { usePictureSets } from "../../../hooks/usePictureSets";

export default ({ orderLine }) => {
  return (
    <PackageInstanceProvider>
      <TemplateInstanceProvider>
        <Wrapper orderLine={orderLine} />
      </TemplateInstanceProvider>
    </PackageInstanceProvider>
  );
};

const Wrapper = ({ orderLine }) => {
  const history = useHistory();
  const { updateItem } = useShoppingCart();
  const { currentPictureSet, pictureSets, setCurrentPictureSet } =
    usePictureSets();
  const {
    initializeInstance,
    packageItems,
    loading,
    dispatch: packageDispatch,
  } = usePackageInstance();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (orderLine.isUpdating || orderLine.isDeleting) {
      return;
    }
    // At this point, we should have an cart update, so redirect:
    history.push("/shopping-cart/");
  }, [orderLine]);

  console.log("Edit order line", orderLine);
  const template = null;

  useEffect(() => {
    const { packageItems } = orderLine.package;

    // We require picturesets to be loaded in case we have to change subject
    if (!pictureSets) {
      return;
    }

    if (
      currentPictureSet?.subject?.uuid != orderLine.package.subject.uuid &&
      editPackageForceSetSameSubject(orderLine.package.allowSubjectChange)
    ) {
      const pictureSet = pictureSets.find(
        (p) => p.subject.uuid == orderLine.package.subject.uuid
      );
      if (pictureSet) {
        setCurrentPictureSet(pictureSet);
      }
    }

    initializeInstance(orderLine.package);
  }, [pictureSets]);

  const handleUpdateCart = () => {
    packageDispatch({
      type: ACTIONS_SET_ADDING_TO_CART,
      payload: {
        isAddingToCart: true,
      },
    });
    updateItem({
      ...orderLine,
      package: {
        ...orderLine.package,
        packageItems,
      },
    });
  };

  if (loading) {
    return <div>Loading</div>;
  }

  return (
    <MobilePage>
      <AppBar disableGutters={true} />
      <GreenScreenBackgroundsProvider jobUuid={currentPictureSet.job.uuid}>
        <EditPackage
          mode={"update"}
          orderLine={orderLine}
          handleUpdateCart={handleUpdateCart}
        />
      </GreenScreenBackgroundsProvider>
    </MobilePage>
  );
};
